import script from "./ViewportBackground.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewportBackground.vue?vue&type=script&lang=ts&setup=true"

import "./ViewportBackground.vue?vue&type=style&index=0&id=b6b18502&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6b18502"]])

export default __exports__